// The task board's wire: the shared room sync (room-sync.mjs) over the task model.
import { apply, cards, decode, emptyState, encode, merge, roomName } from "./tasks.mjs";
import { createRoomSync } from "./room-sync.mjs";

const model = { empty: emptyState, apply, merge, encode, decode };

export function createTasksSync({ team, ...rest }) {
  const sync = createRoomSync({ ...rest, room: roomName(team), model });
  return {
    room: sync.room,
    joined: sync.joined,
    get state() {
      return sync.state;
    },
    cards: () => cards(sync.state),
    do: sync.do,
    close: sync.close,
  };
}
